
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Carousel } from 'antd';

import { CompassOutlined } from '@ant-design/icons';
import { useIsVisible } from '@components';
import { BlueButton } from '@share/components';
import { RootState } from '@share/utils';
import { DEFAULT_MEDIA_POINT, Routes } from '@share/constants';

import './style.scss';

const SPEED = 1000;
const AUTOPLAY_SPEED = 4000;
const SLIDES_TO_SHOW = 3;
const SLIDES_TO_SHOW_MOBILE = 1;
const SLIDES_TO_SCROLL = 1;

interface IProps {
  reference: React.RefObject<HTMLDivElement>;
}

export function SearchAshevillePlayExitingTours({ reference }: IProps) {
  const [elementRef, isVisible] = useIsVisible<HTMLDivElement>();
  
  const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;
  
  const propsCarousel = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: SPEED,
    slidesToShow: isMobile ? SLIDES_TO_SHOW_MOBILE : SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    autoplay: false,
    autoplaySpeed: AUTOPLAY_SPEED,
  };
  
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const account = loginStore?.account;

  const tours = account?.ashevillePlayTours || [];

  const handleBookNow = (title: string) => {
    const name = title?.replace(/\s+/g, '-').toLowerCase().replace(/\.|\,/g, '');
    
    window.open(`/${account?.name}${Routes.TourIframe}/${name}`, '_blank');
  }

  return (
    <div ref={elementRef} className="search-asheville-play-exiting-tours">
      <div ref={reference} className="main_title_2">
        <span><em></em></span>
        <h2>Asheville's Best Deals</h2>
        <p>Carefully curated deals to make your Asheville trip effortlessly fun</p>
      </div>

      <Carousel {...propsCarousel} className={`${isVisible ? 'animated-tours' : ''}`}>
        {tours.map((tour: any, index: number) => (
          <div key={index} className="exiting-tours-carousel-item">
            <div className="exiting-tours-carousel-item__container" style={{ animationDelay: `${index * 0.3}s` }}>
              <img src={tour.src} alt={tour.title} />
              <div className="exiting-tours-carousel-item__content">
                <h3>{tour.title}</h3>
                <p>{tour.subTitle}</p>
                {tour.options?.map((option: string, index: number) => (
                  <ul>
                    <li key={`options-${index}`}>
                      <span><CompassOutlined /> {option}</span>
                    </li>
                  </ul>))}
              </div>
              <div className="excursion-footer">
                <BlueButton onClick={() => handleBookNow(tour.title)}>Book Now</BlueButton>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

